// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eula {
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  z-index: 2;
  font-family: Inter;
}
.eula__container {
  z-index: 3;
  position: fixed;
  display: flex;
  flex-direction: row;
  width: 60rem;
  height: 40rem;
  border-radius: 1rem;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: auto;
  background-color: white;
}
.eula__container__image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40%;
  height: 100%;
  background-color: #F4F7F9;
}
.eula__container__image img {
  width: 80%;
}
.eula__container__agreement {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 3rem;
  width: 60%;
}
.eula__container__agreement__title {
  font-size: 2rem;
  font-weight: 600;
  text-align: flex-start;
}
.eula__container__agreement__text {
  height: 70%;
  overflow-y: auto;
}
.eula__container__agreement__text::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  border: 0.0625rem solid black;
}
.eula__container__agreement__text::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.eula__container__agreement__text::-webkit-scrollbar-thumb {
  background: #888;
  width: 80%;
  padding: 0.0625rem;
}
.eula__container__agreement__text::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.eula__container__agreement__text p {
  text-align: start;
  margin-right: 0.5rem;
  font-size: 1rem;
}
.eula__container__agreement__button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.eula__container__agreement__button-container__button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: black;
  border: 0.0625rem solid #000000;
  width: 7.25rem;
  height: 2.5rem;
  border-radius: 0.1rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/eula/eula.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AACJ;AAAI;EACI,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;EACA,uBAAA;AAER;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAEZ;AADY;EACI,UAAA;AAGhB;AAAQ;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;AAEZ;AADY;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAGhB;AADY;EAmBI,WAAA;EACA,gBAAA;AAfhB;AAHgB;EACI,aAAA;EACA,cAAA;EACA,6BAAA;AAKpB;AAFgB;EACI,mBAAA;AAIpB;AAFgB;EACI,gBAAA;EACA,UAAA;EACA,kBAAA;AAIpB;AAFgB;EACI,gBAAA;AAIpB;AAAgB;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AAEhB;AAEY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAAhB;AACgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AACpB","sourcesContent":[".eula{\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    background-color: rgba($color: #ffffff, $alpha: 0.9);\n    position: absolute;\n    z-index: 2;\n    font-family: Inter;\n    &__container{\n        z-index: 3;\n        position: fixed;\n        display: flex;\n        flex-direction: row;\n        width: 60rem;\n        height: 40rem;\n        border-radius: 1rem;\n        box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        pointer-events: auto;\n        background-color: white;\n\n        &__image{\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            width: 40%;\n            height: 100%;\n            background-color:#F4F7F9;\n            img{\n                width: 80%;\n            }\n        }\n        &__agreement{\n            padding: 1rem;\n            display: flex;\n            flex-direction: column;\n            row-gap: 3rem;\n            width: 60%;\n            &__title{\n                font-size: 2rem;\n                font-weight: 600;\n                text-align: flex-start;\n            }\n            &__text{\n                //edit scrollbar to be blue and without arrows\n                &::-webkit-scrollbar {\n                    width: 0.5rem;\n                    height: 0.5rem;\n                    border: 0.0625rem solid black;\n                    \n                }\n                &::-webkit-scrollbar-track {\n                    background: #f1f1f1;\n                }\n                &::-webkit-scrollbar-thumb {\n                    background: #888;\n                    width: 80%;\n                    padding: 0.0625rem;\n                }\n                &::-webkit-scrollbar-thumb:hover {\n                    background: #555;\n                }\n                height: 70%;\n                overflow-y: auto;\n                p{\n                text-align: start;\n                margin-right: 0.5rem;\n                font-size: 1rem;\n                }\n\n            }\n            &__button-container{\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                &__button{\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-color: transparent;\n                    color: black;\n                    border: 0.0625rem solid #000000;\n                    width: 7.25rem;\n                    height: 2.5rem;\n                    border-radius: 0.1rem;\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
